import Vue from 'vue';
import App from './App.vue';
import router from './router/router';
import HttpRequest from './utils/axios.config';
import Notice from './utils/notice.base';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store';

Vue.use(ElementUI);

Vue.config.productionTip = false;

Vue.prototype.$http = new HttpRequest();
Vue.prototype.$baseNotice = new Notice();

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
